interface FooterSmallConfigModel {
    hotline: string;
    customerServiceEmail: string;
    openingHoursFrom: string;
    openingHoursTo: string;
}

const defaultFooterSmallConfig: Required<FooterSmallConfigModel> = {
    hotline: '22 116 82 96',
    customerServiceEmail: 'info@nocowanie.pl',
    openingHoursFrom: '08:00',
    openingHoursTo: '16:00',
};

export { type FooterSmallConfigModel, defaultFooterSmallConfig };
